/* @flow */

import React from 'react';

import { Route, IndexRoute } from 'react-router';
import { loadRoute, render, ViewerQueries } from 'depop/router';

export default (
  <Route path="about">
    <IndexRoute getComponent={(location, cb) => loadRoute(import('./views/About'), cb)} queries={ViewerQueries} render={render} />
    <Route path="jobs" getComponent={(location, cb) => loadRoute(import('./views/JobList'), cb)} queries={ViewerQueries} render={render} />
    <Route path="jobs/:id" getComponent={(location, cb) => loadRoute(import('./views/JobDetail'), cb)} queries={ViewerQueries} render={render} />
    <Route path="spaces" getComponent={(location, cb) => loadRoute(import('./views/Spaces'), cb)} queries={ViewerQueries} render={render} />
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/apps/about/index.js